// import PropTypes from 'prop-types';

import FormGroup from 'components/FormGroup';
import GlobalContext from 'contexts';
import useFetchData from 'hooks/useFetchData';
import moment from 'moment';
import { useContext } from 'react';
import Api from 'utils/api';

export function DoctorSummeryPredibetes() {
  const { currentMeeting } = useContext(GlobalContext);

  // const { data: clientSurveyMeasure } = useFetchData(
  //   `client-therapist-scheduler/findAllfindByClient/${currentMeeting.clientUuid}`
  // );

  const { data: doctorMeetingSummery } = useFetchData(
    `client-prediabetes-measures/getMedicalSummery/${currentMeeting.clientProductUuid}/true`
  );

  const thisSummary = doctorMeetingSummery?.summery;

  const fields = [
    {
      name: 'value',
      label: 'סיכום',
      required: true,
      type: 'textarea',
      breakLine: true,
      default: thisSummary,
    },
  ];

  const onSubmit = (data) => {
    data.meetingId = currentMeeting.id;
    Api.post(
      `/client-prediabetes-measures/doctorSummery/${currentMeeting.clientProductUuid}`,
      data
    ).then(() => {
      window.location.reload();
    });
  };

  return (
    <div>
      <div>
        סיכום פגישה עם רופא - טרום סכרת
        {doctorMeetingSummery?.value && doctorMeetingSummery?.lastUpdated && (
          <span>
            {' '}
            נכתב ב־
            {moment(doctorMeetingSummery.lastUpdated).format(
              'DD.MM.YYYY HH:mm'
            )}
          </span>
        )}
      </div>
      {doctorMeetingSummery && (
        <FormGroup
          fields={fields}
          data={doctorMeetingSummery}
          onSubmit={onSubmit}
        ></FormGroup>
      )}
      {doctorMeetingSummery?.value && (
        <span>נכתב ע"י {doctorMeetingSummery.updatedBy}</span>
      )}
    </div>
  );
}
